import { useNavigate } from "react-router-dom";
import { LoginForm } from "../design-system/components/security/Security";
import api from "../services/api";


function Login() {

  const navigate = useNavigate();


  async function handleLogin({ email, password }) {

    try {

      const resposta = await api.post(
        "/auth/login.php",
        {
          email: email,
          senha: password
        }
      );


      console.log(resposta.data);


      if(resposta.data.status === "ok") {


        localStorage.setItem(
          "sessionToken",
          resposta.data.usuario.id
        );


        localStorage.setItem(
          "usuario",
          JSON.stringify(resposta.data.usuario)
        );


        navigate("/dashboard");


      } else {

        alert(resposta.data.mensagem);

      }


    } catch(error) {

      console.error(error);

      alert("Erro ao conectar com servidor");

    }

  }


  function handleForgotPassword(){

    navigate("/recuperarsenha");

  }


  return (

    <div className="min-h-screen bg-background flex items-center justify-center">

      <LoginForm
        onSubmit={handleLogin}
        onForgotPassword={handleForgotPassword}
      />

    </div>

  );

}


export default Login;